import Vue from "vue";
import UserProfile from "./UserProfile.vue";

export function load() {
  const selector = "userprofile-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(UserProfile, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
